
import { testimonials } from '@/lib/mock-data';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';

export function TestimonialCarousel() {
  // Duplicate testimonials to create a seamless loop
  const extendedTestimonials = [...testimonials, ...testimonials, ...testimonials, ...testimonials];

  return (
    <div className="w-full overflow-hidden">
      {/* @ts-ignore - Framer Motion types compatibility */}
      <motion.div
        className="flex gap-4 w-max"
        {...({
          animate: { x: ["0%", "-50%"] },
          transition: {
            repeat: Infinity,
            ease: "linear",
            duration: 30,
          },
        } as any)}
      >
        {extendedTestimonials.map((testimonial, index) => (
          <div
            key={index}
            className="w-[300px] flex-shrink-0 bg-white px-6 py-4 rounded-lg space-y-3 border border-gray-100 shadow-sm"
          >
            {/* Avatar and Rating */}
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Avatar className="w-10 h-10">
                  <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                  <AvatarFallback>{testimonial.author[0]}</AvatarFallback>
                </Avatar>
                <div className="flex gap-1">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                      key={i}
                      className={`w-3.5 h-3.5 ${
                        i < testimonial.rating
                          ? 'fill-yellow-400 text-yellow-400'
                          : 'text-gray-300'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </div>

            {/* Text */}
            <p className="text-sm font-casual text-gray-700 leading-relaxed line-clamp-4">
              {testimonial.text}
            </p>

            {/* Author */}
            <p className="text-xs font-semibold text-gray-900">{testimonial.author}</p>
          </div>
        ))}
      </motion.div>
    </div>
  );
}
